import MicroModal from "micromodal";

export default function triggerModal() {
  MicroModal.init();
}
